// Per-product OpenLoop intake URL placeholders.
// Replace these with real white-labeled intake links.
export const INTAKE_URLS = {
  glp1: "https://intake.openloophealth.com/meridian/glp1",
  peptides: "https://intake.openloophealth.com/meridian/peptides",
  longevity: "https://intake.openloophealth.com/meridian/longevity",
  hormones: "https://intake.openloophealth.com/meridian/hormones",
  wholeHealth: "https://intake.openloophealth.com/meridian/whole-health",
  microdosing: "https://intake.openloophealth.com/meridian/microdosing",
  default: "https://intake.openloophealth.com/meridian",
} as const;

export type IntakeKey = keyof typeof INTAKE_URLS;

export const PORTAL_URL = "https://portal.openloophealth.com/meridian";

/**
 * Pre-launch flag. While `false`, every primary CTA across the site routes to
 * the waitlist modal instead of live intake. Flip to `true` at launch and the
 * entire UI reverts to direct intake links automatically.
 */
export const LAUNCHED = false;
